import { drivers } from '../config';
export = drivers.pg;
